import useSafeStateA10 from '@aims/shared/shared/use-safe-state-a10';
import { useApolloClient } from '@apollo/client';
import { Modal } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { adoptionForAdminQuery } from '../../adoptions/constants';
import { ppPayerQuery } from '../payers/constants';
import { ppRecurringPaymentQuery } from '../recurring-payments/constants';
import AdmContactPageA10 from './AdmContactPageA10';
import AdmInitPageA10 from './AdmInitPageA10';
import AdmRecurringQuestionPageA10 from './AdmRecurringQuestionPageA10';
import AdmSponsorshipPageA10 from './AdmSponsorshipPageA10';
import AdmSummaryPageA10 from './AdmSummaryPageA10';
import { viewProjectSponsorshipQuery } from '../../../project-sponsorships/ViewSponsorship/ViewSponsorshipPage';
import settings from '../../../settings';

function AssociateDonationsModalA10({ visible, onCancel, onDone }) {
  const { payment, isRecurring } = visible || {};
  const [page, setPage] = useState('init');
  const [contact, setContact] = useState();
  const [recurringPayment, setRecurringPayment] = useState();
  const [payer, setPayer] = useState();
  const client = useApolloClient();
  const [adoptionItems, setAdoptionItems, _adoptionItems] = useSafeStateA10([]);

  console.log('payment', payment);

  const fundType = useMemo(() => {
    if (payment?.fundId === settings.holisticSustainabilityFund) {
      return 'holistic';
    } else if (payment?.fundId === settings.sponsorANativeMissionaryFund) {
      return 'upg';
    }
  }, [payment]);

  const onRemoveAdoption = (record) => {
    setAdoptionItems(adoptionItems.filter((a) => a._id !== record._id));
  };
  const onAddAdoptionItem = useCallback(
    (item, name) => {
      const percent = 1.0 / (_adoptionItems.current.length + 1);
      setAdoptionItems([
        ..._adoptionItems.current.map((a) => ({
          ...a,
          percent,
          usdCentsAmount: payment.usdCentsAmount * percent,
        })),
        {
          _id: item._id,
          [name]: item,
          percent,
          usdCentsAmount: payment.usdCentsAmount * percent,
          edited: false,
        },
      ]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [payment],
  );
  const fetchAndAddAdoption = useCallback(
    async (a) => {
      const resp2 = await client.query({
        query: adoptionForAdminQuery,
        variables: {
          _id: a.adoptionId,
        },
      });
      const adoption = resp2?.data?.adoptionForAdmin;
      if (adoption) {
        onAddAdoptionItem(adoption, 'adoption');
      }
    },
    [client, onAddAdoptionItem],
  );
  const fetchAndAddSponsorship = useCallback(
    async (a) => {
      const resp2 = await client.query({
        query: viewProjectSponsorshipQuery,
        variables: {
          _id: a.sponsorshipId,
        },
      });
      const project = resp2?.data?.projectSponsorshipForAdmin?.project;
      if (project) {
        onAddAdoptionItem(project, 'project');
      }
    },
    [client, onAddAdoptionItem],
  );

  useEffect(() => {
    async function doAsyncStuff() {
      let resp = await client.query({
        query: ppPayerQuery,
        variables: {
          _id: payment.payerId,
        },
      });
      if (resp?.data?.ppPayerForAdmin) {
        setPayer(resp.data.ppPayerForAdmin);
      }
      if (payment.adoptions && payment.adoptions.length > 0) {
        await Promise.all(
          payment.adoptions.map(async (a) => {
            await fetchAndAddAdoption(a);
          }),
        );
      } else if (payment.sponsorships && payment.sponsorships.length > 0) {
        await Promise.all(
          payment.sponsorships.map(async (a) => {
            await fetchAndAddSponsorship(a);
          }),
        );
      }
      if (!isRecurring && payment.recurringPaymentToken) {
        resp = await client.query({
          query: ppRecurringPaymentQuery,
          variables: {
            _id: payment.recurringPaymentToken,
          },
        });
        const recurring = resp?.data?.ppRecurringPaymentForAdmin;
        if (recurring) {
          setRecurringPayment(recurring);
          if (recurring.adoptions && recurring.adoptions.length > 0) {
            await Promise.all(
              recurring.adoptions.map(async (a) => {
                await fetchAndAddAdoption(a);
              }),
            );
          } else if (
            recurring.sponsorships &&
            recurring.sponsorships.length > 0
          ) {
            await Promise.all(
              recurring.sponsorships.map(async (a) => {
                await fetchAndAddSponsorship(a);
              }),
            );
          }
        }
      } else if (payment.suggestedAllocations?.length > 0) {
        await Promise.all(
          payment.suggestedAllocations.map(async (a) => {
            if (a.adoptionId) {
              await fetchAndAddAdoption(a);
            } else if (a.sponsorshipId) {
              await fetchAndAddSponsorship(a);
            }
          }),
        );
      }
      setPage('contact');
    }
    if (payment) {
      setAdoptionItems([]);
      doAsyncStuff();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client, payment, isRecurring, onAddAdoptionItem]);

  console.log('page', page);

  return (
    <Modal
      open={visible}
      closable={false}
      destroyOnClose={true}
      maskClosable
      cancelText="Cancel"
      okText="Change Password"
      footer={null}
      onCancel={onCancel}
      width={700}
      styles={{
        body: {
          paddingTop: 32,
        },
      }}
    >
      {page === 'init' && <AdmInitPageA10 />}
      {page === 'contact' && (
        <AdmContactPageA10
          payment={payment}
          payer={payer}
          isRecurring={isRecurring}
          recurringPayment={recurringPayment}
          contact={contact}
          setContact={setContact}
          setPage={setPage}
          adoptionItems={adoptionItems}
        />
      )}
      {page === 'existing' && (
        <AdmRecurringQuestionPageA10
          payment={payment}
          payer={payer}
          recurringPayment={recurringPayment}
          setPage={setPage}
          adoptionItems={adoptionItems}
          onRemoveAdoption={onRemoveAdoption}
          fundType={fundType}
        />
      )}
      {page === 'sponsorship' && (
        <AdmSponsorshipPageA10
          payment={payment}
          payer={payer}
          isRecurring={isRecurring}
          recurringPayment={recurringPayment}
          setPage={setPage}
          adoptionItems={adoptionItems}
          onAddAdoptionItem={onAddAdoptionItem}
          fundType={fundType}
        />
      )}
      {page === 'summary' && (
        <AdmSummaryPageA10
          payment={payment}
          payer={payer}
          recurringPayment={recurringPayment}
          isRecurring={isRecurring}
          setPage={setPage}
          adoptionItems={adoptionItems}
          onRemoveAdoption={onRemoveAdoption}
          onAddAdoptionItem={onAddAdoptionItem}
          onCancel={onCancel}
          contact={contact}
          onDone={onDone}
          fundType={fundType}
        />
      )}
    </Modal>
  );
}

export default AssociateDonationsModalA10;
